// eslint-disable-next-line max-len
import { LaboratorySpecificSetting } from 'src/app/modules/admin/components/shared/components/laboratory-specific-settings/models/laboratory-specific-setting.model';
import { ActionWithSettings } from '../../services/dtos/actionWithSettings';

export class SetCurrentActionId {
  public static readonly type = '[Actions] Set Current Action Id';
  public constructor(public id: string) { }
}

export class ClearCurrentActionId {
  public static readonly type = '[Actions] Clear Current Action Id';
}

export class FetchAllActionsBasicInfo {
  public static readonly type = '[Actions] Fetch All Basic Info';
}

export class FetchAction {
  public static readonly type = '[Actions] Fetch';
  public constructor(public id: string) { }
}

export class UpdateAction {
  public static readonly type = '[Actions] Update';
  public constructor(public payload: ActionWithSettings) { }
}

export class AddActionLaboratorySpecificSetting {
  public static readonly type =
    '[Actions] Add Action Laboratory Specific Setting';
  public constructor(public payload: LaboratorySpecificSetting) {}
}

export class UpdateActionLaboratorySpecificSetting {
  public static readonly type =
    '[Actions] Update Action Laboratory Specific Setting';
  public constructor(public settingId: string, public payload: LaboratorySpecificSetting) {}
}

export class DeleteActionLaboratorySpecificSetting {
  public static readonly type =
    '[Actions] Delete Action Laboratory Specific Setting';
  public constructor(public actionId: string, public settingId: string) {}
}

